import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// Shared shell for site-wide legal/info pages (Refund Policy, FAQ) — plain,
// readable, printable. Mirrors src/components/Kids/LegalPage.jsx but links
// back to the main site instead of Cabil Kids.
export default function LegalShell({ title, updated, children }) {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-white font-sans">
      <header className="border-b border-gray-200 bg-white">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="font-bold text-lg text-slate-800">
            Cabil
          </Link>
          <Link to="/" className="text-sm font-semibold text-slate-500 hover:text-orange-600 transition">
            {t("nav.backToHome")}
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-10">
        <h1 className="font-bold text-3xl text-slate-900 mb-1">{title}</h1>
        {updated && <p className="text-sm text-slate-500 mb-8">Last updated {updated}</p>}
        <div className="prose-legal text-slate-800 text-[15px] leading-relaxed space-y-6">
          {children}
        </div>
      </main>

      <style>{`
        .prose-legal h2 { font-weight:700; font-size:19px; color:#1E293B; margin-top:8px; }
        .prose-legal p, .prose-legal li { color:#334155; }
        .prose-legal ul { list-style: disc; padding-inline-start: 1.4rem; }
        .prose-legal a { color:#EE5F2B; font-weight:700; }
      `}</style>
    </div>
  );
}
